module.exports = __webpack_public_path__ + "static/media/buttons.05bd2471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameProgramRobot/buttons.png
// module id = 2448
// module chunks = 0